import { useEffect, useState } from 'react';
import {
 useFragment, graphql, fetchQuery, useRelayEnvironment,
} from 'react-relay';
import { nanoid } from 'nanoid';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import { lang } from '@/helpers/translate';

/*
Listen which marker, pin click and load space data belong to
and up to store, for the right listener pin marker
all of them will catch result but th only right open, other close
*/
const fragmentMarkerPin = graphql`
  fragment markerpinEventByRefs on Query @argumentDefinitions (refs: {type: "[String!]"}) {
    results: spaceGetByRefs(refs: $refs) {
      ref
      title
      dataByCategory(category: "production") {
        price {
          amount_excl_tax
        }
      }
      pictures(count:3) {
        nameId
        extension
        predictName
      }
      urlSpacefr: urlByLang(lang: "fr")
      urlSpaceen: urlByLang(lang: "en")
      urlSpacees: urlByLang(lang: "es")
    }
  }
`;

const queryMarkerPin = graphql`
  query markerpinByRefsQuery ($refs: [String!]) {
    ...markerpinEventByRefs @arguments(refs: $refs)
  }
`;

function PinEvent() {
  const pinEvent = useSearchZustandStore((state) => state.pinEvent);

  useEffect(() => {
    if (pinEvent?.action && pinEvent?.data) {
      // console.log('search/event/markerpin call', pinEvent);
      let spaceRefs = [];
      if (pinEvent.action.match(/^clusterclick/)) {
        const { markers } = pinEvent?.data || {};
        spaceRefs = (markers || []).reduce((acc, m) => {
          acc.push(m?.markerprops?.iid);
          return acc;
        }, []);
      } else if (pinEvent.action.match(/^pinclick/)) {
        spaceRefs = pinEvent.data?.spaceRefs || [];
      }
      // if (!spaceRefs?.length) return console.log('search/event/markerpin ERROR, PC, no space');
      if (spaceRefs?.length) {
        useSearchZustandStore.setState({
          varPin: {
            spaceRefs,
            runId: nanoid(),
            pinIdOpen: pinEvent?.data?.pinId || nanoid(),
          },
        });
      }
    }
  }, [pinEvent]);
  return null;
}

function PinSpace({ data, pinIdOpen }) {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!data?.results?.length) return useSearchZustandStore.setState({ pinData: null });
    const { pinEvent } = useSearchZustandStore.getState();
    // console.log('search/event/markerpin space result', pinEvent.action, data?.results);
    useSearchZustandStore.setState({
      pinData: {
        caller: pinEvent.action,
        spaces: data?.results,
        latlng: pinEvent?.data?.latlng,
      },
      pinIdOpen,
    });
    // return console.log('search/event/markerpin event PINSPACE data', data);
  }, [data?.results]);
  return null;
}

function RefetchPinSpace({ data: dataData, ...props }) {
  const data = useFragment(fragmentMarkerPin, dataData);
  return <PinSpace {...{ data }} {...props} />;
}

function PinSpaceContainer() {
  const langCurrent = lang();
  const varPin = useSearchZustandStore((state) => state.varPin);
  const { spaceRefs, pinIdOpen } = varPin || {};

  const [data, setData] = useState(null);
  const environment = useRelayEnvironment();
  useSearchZustandStore.setState({ languageCurrent: langCurrent });

  // console.log('search/event/markerpin PinSpaceContainer', varPin);
  useEffect(() => {
    if (Object.entries(varPin).length) {
      fetchQuery(environment, queryMarkerPin, {
        refs: spaceRefs || [],
      }).subscribe({
        next: (dataRes) => {
          // Pas besoin de retourner quoi que ce soit ici
          setData(dataRes);
        },
        error: (error1) => {
          console.log('error1', error1);
        },
      });
    }
    // Assurez-vous également qu'il n'y a pas de `return` après cette condition
  }, [varPin]);

  return (
    <>
      <RefetchPinSpace {...{ data, pinIdOpen }} />
      <PinEvent />
    </>
  );
}

export default PinSpaceContainer;
